// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".new-navbar-mobile-menu[data-v-319b8e4f]{border-radius:1.6rem;width:-webkit-min-content;width:-moz-min-content;width:min-content;top:7rem}.fade-enter-active[data-v-319b8e4f],.fade-leave-active[data-v-319b8e4f]{transition:opacity .5s}.fade-enter[data-v-319b8e4f],.fade-leave-to[data-v-319b8e4f]{opacity:0}@media (min-width:1024px){.new-navbar-mobile-menu[data-v-319b8e4f]{top:11rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
